import { avatarSizes, cssToken } from "@certn/cascadia";
import { css, cx } from "@emotion/css";

import { VerifiedBadge } from "./VerifiedBadge";
import { AvatarBaseProps } from "./types";

export function _Avatar(props: AvatarBaseProps) {
  const {
    children,
    backgroundColor,
    fontColor,
    size = "small",
    testID = "avatar",
    displayVerifiedBadge = false,
  } = props;

  const sizeStyle = avatarStyles[size];

  return (
    <div className={cx(sizeStyle, styles.wrapper)}>
      <div
        className={cx(styles.container, sizeStyle, props.className)}
        style={{
          color: cssToken(fontColor),
          background: cssToken(backgroundColor),
        }}
        data-testid={testID}
      >
        {children}
      </div>
      {displayVerifiedBadge && <VerifiedBadge />}
    </div>
  );
}

const styles = {
  wrapper: css({
    position: "relative",
  }),
  container: css({
    position: "relative",
    overflow: "hidden",
    alignItems: "center",
    fill: "var(--text-inverse)",
    color: "var(--text-inverse)",
    display: "flex",
    justifyContent: "center",
    borderRadius: "var(--border-radius-half)",
    fontWeight: "var(--font-weight-medium)",
    fontFamily: "var(--font-family-default)",
    "> *": css({
      width: "100%",
      height: "100%",
    }),
  }),
};

export const avatarStyles = Object.entries(avatarSizes).reduce<
  Record<string, string>
>(
  (acc, [key, value]) => ({
    ...acc,
    [key]: css({
      width: cssToken(value.width),
      height: cssToken(value.height),
      fontSize: cssToken(value.fontSize),
    }),
  }),
  {}
);
